import { createAppKit } from '@reown/appkit/react'
import { EthersAdapter } from '@reown/appkit-adapter-ethers'
import { arbitrum, bsc, bscTestnet } from '@reown/appkit/networks'

// 1. Get projectId
const projectId = '256ca7fab127b3461673bebe17f0c745';

// 2. Set the networks
const networks = [bsc, bscTestnet];

// 3. Create a metadata object - optional
const metadata = {
  name: 'My Website',
  description: 'My Website description',
  url: 'https://mywebsite.com', // origin must match your domain & subdomain
  icons: ['https://avatars.mywebsite.com/']
}

// 4. Create a AppKit instance
createAppKit({
  adapters: [new EthersAdapter()],
  networks,
  metadata,
  projectId,
  features: {
    analytics: true, // Optional - defaults to your Cloud configuration
    // analytics: false, // Optional - defaults to your Cloud configuration
    email: false, // default to true
    socials: [],
    // emailShowWallets: true, // default to true
  },
  allWallets: 'ONLY_MOBILE', // default to SHOW
})

export default function Web3Provider({ children }) {
  return <>{children}</>
}